import React, { Component } from "react";
 import { BootstrapInput } from "app/components/common/BootStrapInput";
import BarChart from "components/charts/BarChart";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import "./Overview.css"

import { FormControl, MenuItem, Select, Typography } from "@mui/material";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  addPropsToSeries(series, type) {
    let color = type === 0 ? "#6AA4DC" : type === 1 ? "#96D9E4" : "#FFB607";
    return series.map((el, i) => ({
      color: color,
      borderColor: color,
      name: el.name,
      y: Math.round(el.data[type]),
      type: type,
    }));
  }

  render() {
    return (
      <div
        className="graph-wrapper screen-left-graph-container"
        style={{ height: 915 }}
      >
        <div
          className="graph-title-container"
          style={{ paddingBottom: "45px" }}
        >
          <div className="graph-title">Regional Score</div>
          <div className="graph-dropdown">
            <FormControl sx={{ width: "290px", marginTop: "20px" }}>
              {/* <Typography variant="inherit" className="form-metrics-header">
                Select a region
              </Typography> */}
              <Select
                value={this.props.regionSelected}
                onChange={this.props.handleRegionChange}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                className="select-mui"
                displayEmpty
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select a region
                  </Typography>
                </MenuItem>
                {this.props.regions.length
                  ? this.props.regions.map((name, i) => (
                      <MenuItem key={i} value={name}>
                        <Typography variant="inherit" noWrap>
                          {name}
                        </Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="graph-screen graph-screen1">
          <div className="legend-for-graph legend-for-graph-1">
            <table>
              <tr>
                <td
                  className="square-shape"
                  style={{ backgroundColor: "#6AA4DC" }}
                ></td>
                <td className="legend-label">Education Score</td>
                <td
                  className="square-shape"
                  style={{ backgroundColor: "#96D9E4" }}
                ></td>
                <td className="legend-label">Economy Score</td>
                <td
                  className="square-shape"
                  style={{ backgroundColor: "#FFB607" }}
                ></td>
                <td className="legend-label">Overall Score</td>
              </tr>
            </table>
          </div>
          <div className="individual-graph-1">
            <BarChart
              containerId="barChart"
              stacking={null}
              remainingOptions={{
                chart: {
                  animation: false,
                  type: "bar",
                  backgroundColor: "transparent",
                  height: 225,
                  width: 700,
                  spacingTop: 27,
                },
                series: {
                  name: "Education",
                  data: this.addPropsToSeries(this.props.scoresData, 0),
                },
                xAxis: {
                  // categories: ["County", "Arizona", "Similar Counties", "United States"],
                  type: "category",
                  title: {
                    text: null,
                  },
                  labels: {
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                },
                yAxis: {
                  labels: {
                    enabled: false,
                  },
                  title: {
                    text: null,
                  },
                  gridLineWidth: 0,
                },
                legend: {
                  enabled: false,
                },
              }}
            />
          </div>

          <div className="individual-graph-1">
            <BarChart
              containerId="barChart"
              stacking={null}
              remainingOptions={{
                chart: {
                  animation: false,
                  type: "bar",
                  backgroundColor: "transparent",
                  height: 230,
                  width: 700,
                  spacingTop: 45,
                },
                series: {
                  name: "Economy Score",
                  data: this.addPropsToSeries(this.props.scoresData, 1),
                },
                xAxis: {
                  // categories: ["County", "Arizona", "Similar Counties", "United States"],
                  type: "category",
                  title: {
                    text: null,
                  },
                  labels: {
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                },
                yAxis: {
                  labels: {
                    enabled: false,
                  },
                  title: {
                    text: null,
                  },
                  gridLineWidth: 0,
                },
                legend: {
                  enabled: false,
                },
              }}
            />
          </div>

          <div className="individual-graph-1">
            <BarChart
              containerId="barChart"
              stacking={null}
              remainingOptions={{
                chart: {
                  animation: false,
                  type: "bar",
                  backgroundColor: "transparent",
                  height: 288,
                  width: 700,
                  spacingTop: 50,
                },
                series: {
                  name: "Overall Score",
                  data: this.addPropsToSeries(this.props.scoresData, 2),
                },
                xAxis: {
                  // categories: ["County", "Arizona", "Similar Counties", "United States"],
                  type: "category",
                  title: {
                    text: null,
                  },
                  labels: {
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                },
                yAxis: {
                  title: {
                    text: "Score",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                    y: 10,
                  },
                  labels: {
                    overflow: "justify",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                  gridLineWidth: 0,
                },
                legend: {
                  enabled: false,
                },
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Overview;
